import moment from 'moment';

const CardInfo = ({author, createdAt, updatedAt}, context = {}) => {
  const {utils: {user: {id: userId} = {}} = {}} = context;
  const freshnessAction = (new Date(createdAt)) < (new Date(updatedAt)) ? 'Updated' : 'Created';
  const freshnessAuthor = author ? (
    <i>
      {`${freshnessAction} by `}
      <a href={`/users/${author.id}`}>
        {userId === author.id ? 'You' : author.name}
      </a>
    </i>
  ) : null;
  const freshnessTime = (
    <time>
      {`${author ? '' : freshnessAction}
        ${moment(freshnessAction === 'Updated' ? updatedAt : createdAt).fromNow()}`}
    </time>
  );

  return (
    <small className="card-info">
      {freshnessAuthor}
      {freshnessTime}
    </small>
  );
};

CardInfo.propTypes = {
  author: PropTypes.object,
  createdAt: PropTypes.string,
  updatedAt: PropTypes.string
};

CardInfo.defaultProps = {
  author: null,
  createdAt: '',
  updatedAt: ''
};

CardInfo.contextTypes = {
  utils: PropTypes.object
};

export default CardInfo;
